/**
 * Stay Connected — Logo Ticker
 *
 * Converts each `.corsa-stay-connected__logos` group into an infinite
 * horizontal marquee. Existing children are moved into a flex track
 * which is duplicated once so a translateX(-50%) keyframe loops
 * seamlessly. CSS handles the visual animation.
 */

function initLogoTickers() {
	const containers = document.querySelectorAll( '.corsa-stay-connected__logos' );

	containers.forEach( ( container ) => {
		if ( container.classList.contains( 'is-ticker' ) ) {
			return;
		}

		const items = Array.from( container.children );
		if ( ! items.length ) {
			return;
		}

		const track = document.createElement( 'div' );
		track.className = 'corsa-stay-connected__logos-track';

		items.forEach( ( item ) => track.appendChild( item ) );

		// Duplicate so translating the track -50% lines the cloned half
		// up exactly where the originals started — the loop is seamless.
		Array.from( track.children ).forEach( ( item ) => {
			const clone = item.cloneNode( true );
			clone.setAttribute( 'aria-hidden', 'true' );
			track.appendChild( clone );
		} );

		container.appendChild( track );
		container.classList.add( 'is-ticker' );
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initLogoTickers );
} else {
	initLogoTickers();
}
